import {
    Breakpoints,
    CssClassNames,
    HeaderHeight,
    MinSpaceBeforeDirectionReverse,
    MoreMenuMinSpace,
    Selectors,
    SubMenuWidth,
} from './constants';
import {
    keyCodeArrowDown,
    keyCodeArrowUp,
    keyCodeEnter,
    keyCodeEscape,
    keyCodeSpace,
    keyCodeTab,
} from '@bapiweb-ux/web-utilities';

import $ from 'jquery';

// Polyfill for Array.from for IE
import 'core-js/features/array/from';
import { debounce } from 'lodash-es';

export class BapiHeader {
    $rootContainer: JQuery<HTMLElement>;
    $topbarContainer: JQuery<HTMLElement>;
    $logo: JQuery<HTMLDivElement>;
    $brand: JQuery<HTMLDivElement>;
    $separator: JQuery<HTMLDivElement>;
    $hamburgerMenuButton: JQuery<HTMLButtonElement>;
    $leftMenu: JQuery<HTMLUListElement>;
    $rightMenu: JQuery<HTMLUListElement>;
    $moreMenu: JQuery<HTMLLIElement>;
    $moreMenuList: JQuery<HTMLUListElement>;
    $moreMenuButton?: JQuery<HTMLButtonElement>;
    $meControlDesktop: JQuery<HTMLDivElement>;
    $meControlMobile: JQuery<HTMLDivElement>;
    meControlOptions: any;
    IsMoreMenuAdjustmentsInProgress: boolean;

    public load(): void {
        $(document).ready((): void => {
            this.findDOMElements();

            this._addEventHandlers();

            $(window).trigger('resize');

            $(window).on('unload', this.onUnmountEventHandlers);
        });
    }

    private findDOMElements(): void {
        this.$rootContainer = $(Selectors.ROOT_CONTAINER) as JQuery<HTMLDivElement>;

        this.$topbarContainer = $(Selectors.TOPBAR_CONTAINER) as JQuery<HTMLDivElement>;

        this.$logo = this.$rootContainer.find(Selectors.LOGO) as JQuery<HTMLDivElement>;

        this.$brand = this.$rootContainer.find(Selectors.BRAND) as JQuery<HTMLDivElement>;

        this.$separator = this.$rootContainer.find(Selectors.SEPARATOR) as JQuery<HTMLDivElement>;

        this.$leftMenu = this.$rootContainer.find(Selectors.MENU_LEFT) as JQuery<HTMLUListElement>;

        this.$rightMenu = this.$rootContainer.find(Selectors.MENU_RIGHT) as JQuery<HTMLUListElement>;

        this.$hamburgerMenuButton = this.$rootContainer.find(Selectors.HAMBURGER_MENU) as JQuery<HTMLButtonElement>;

        this.$moreMenu = this.$rootContainer.find(Selectors.MORE_MENU) as JQuery<HTMLLIElement>;

        this.$moreMenuList = this.$rootContainer.find(Selectors.MORE_MENU_LIST) as JQuery<HTMLUListElement>;

        this.$moreMenuButton = this.$rootContainer.find(Selectors.MORE_MENU_BUTTON) as JQuery<HTMLButtonElement>;

        this.$meControlDesktop = $(Selectors.ME_CONTROL) as JQuery<HTMLDivElement>;

        this.$meControlMobile = $(Selectors.ME_CONTROL_MOBILE) as JQuery<HTMLDivElement>;
    }

    private _addEventHandlers(): void {
        // Bind & Register Event Handlers
        this.onHandleMenuClick = this.onHandleMenuClick.bind(this);
        this.onHandleMenuKeydown = this.onHandleMenuKeydown.bind(this);
        this.onHandleFocus = this.onHandleFocus.bind(this);
        this.onHandleHamburgerMenuClick = this.onHandleHamburgerMenuClick.bind(this);
        this.onHandleDocumentClick = this.onHandleDocumentClick.bind(this);
        this.onHandleWindowResize = this.onHandleWindowResize.bind(this);
        this.debouncedOnHandleWindowsResize = this.debouncedOnHandleWindowsResize.bind(this);
        this.onHandleWindowScroll = this.onHandleWindowScroll.bind(this);
        this.debouncedOnHandleWindowScroll = this.debouncedOnHandleWindowScroll.bind(this);
        this.onHandleHamburgerKeydown = this.onHandleHamburgerKeydown.bind(this);
        this.onHandleDocumentKeydown = this.onHandleDocumentKeydown.bind(this);
        this.onHandleLastMenuItemKeydown = this.onHandleLastMenuItemKeydown.bind(this);
        this.onHandleFirstMenuItemKeydown = this.onHandleFirstMenuItemKeydown.bind(this);
        this.onUnmountEventHandlers = this.onUnmountEventHandlers.bind(this);
        this.onHandleSubMenuItemFocus = this.onHandleSubMenuItemFocus.bind(this);

        if (this.$rootContainer.length === 0) {
            return;
        }

        // Dropdown Menu
        this.$rootContainer.on('mousedown keydown', `${Selectors.MENU_BUTTON}`, this.onHandleMenuClick);

        this.$rootContainer.on('focus', `${Selectors.MENU_BUTTON}`, this.onHandleFocus);

        this.$rootContainer.on('focus', `${Selectors.MENU_LINK}`, this.onHandleFocus);

        this.$rootContainer.on(
            'focus',
            '.is-dropdown-submenu > li > a, .is-dropdown-submenu > li > button',
            this.onHandleSubMenuItemFocus
        );

        // Tab key on last menu element should close the sub-menu before moving
        // focus to right menu.
        this.$leftMenu.on('keydown', Selectors.MENU_LEFT_LAST_ELEMENT, this.onHandleLastMenuItemKeydown);

        // Hamburger menu uses absolute positioning.
        // On Shift + Tab, move the focus to hamburger menu button.
        this.$leftMenu.on('keydown', Selectors.MENU_LEFT_FIRST_ELEMENT, this.onHandleFirstMenuItemKeydown);

        // Support Up/Down Arrow keys within submenu.
        this.$rootContainer.on(
            'keydown',
            '.is-dropdown-submenu > li > a, .is-dropdown-submenu > li > button',
            this.onHandleMenuKeydown
        );

        // Only bind hamburger events if hamburger element is on dom.
        // Set if "HEADER_SIMPLE" class to adjust the height of the header.
        if (this.$hamburgerMenuButton && this.$hamburgerMenuButton.length) {
            this.$hamburgerMenuButton.on('click', this.onHandleHamburgerMenuClick);

            this.$hamburgerMenuButton.on('keydown', this.onHandleHamburgerKeydown);
        } else {
            this.$rootContainer.addClass(CssClassNames.HEADER_SIMPLE);
        }

        // Window & Document
        $(document).on('click', this.onHandleDocumentClick);
        $(document).on('keydown', this.onHandleDocumentKeydown);

        $(window).on('resize', this.debouncedOnHandleWindowsResize);

        if (this.$rootContainer.data('stickyHeader')) {
            $(window).on('scroll', this.debouncedOnHandleWindowScroll);
        }

        if (this.useMeControl && this.$meControlDesktop.length > 0) {
            this.loadMeControl(Selectors.ME_CONTROL_ID);
        }
    }

    loadMeControl(id: string): void {
        const meControl: HTMLElement = document.getElementById(id);
        const signInSettingsJson: string = meControl && meControl.getAttribute(Selectors.DATA_SIGN_IN_SETTINGS);

        try {
            this.meControlOptions = JSON.parse(signInSettingsJson);

            if (!this.meControlOptions || Object.keys(this.meControlOptions).length === 0) return;

            this.meControlOptions.containerId = id;
            meControl.setAttribute(Selectors.DATA_SIGN_IN_SETTINGS, JSON.stringify(this.meControlOptions));

            // Initialize MeControl
            this.initializeMeControl(this.meControlOptions);
        } catch (e) {
            /* tslint:disable no-console */
            console.error('Loading MeControl failed');
            /* tslint:enable no-console */
        }
    }

    initializeMeControl(signInSettings: any): void {
        const fallbackTimeout: number = 1000;

        const w: any = window;

        if (w?.MeControl) {
            this.loadMe(w, signInSettings);
        } else {
            // If for any reason the call to https://controls.account.microsoft.com/me takes too long, revert to the simple HTML fallback
            // If that call ever returns, onMeControlReadyToLoad will get triggered and the MeControl will override the fallback HTML
            const timerId: NodeJS.Timeout = setTimeout(this.showMeControlFallback.bind(this), fallbackTimeout);

            w.onMeControlReadyToLoad = function (): void {
                // Clear fallback timer
                clearTimeout(timerId);

                // Load ME
                this.loadMe(w, signInSettings);
            };
        }
    }

    private loadMe(w: any, signInSettings: any): void {
        // Load MeControl
        try {
            w.MeControl.Loader.loadAsync(signInSettings).then(this.onHandleWindowResize);

            // Clear ready callback
            w.onMeControlReadyToLoad = null;
        } catch (e) {
            /* tslint:disable no-console */
            console.error('MeControl Initialization failed');
            /* tslint:enable no-console */
        }
    }

    private setMeControlMobileState(displayMode: string): void {
        if (!this.useMeControl) return;

        const w: any = window;
        if (w?.MeControl) {
            try {
                w.MeControl.API.setDisplayMode(displayMode);
            } catch (e) {
                /* tslint:disable no-console */
                console.error('MeControl setDisplayMode API call failed');
                /* tslint:enable no-console */
            }
        }
    }

    private showMeControlFallback(): void {
        const _options: any = this.meControlOptions;

        if (!_options) {
            return;
        }

        const authConfig: any = _options?.authProviderConfig;

        let authBtnTxt: string;

        let authLink: string;

        // Feel free to inject localized strings for Sign in and Sign out

        if (_options?.currentAccount?.authenticatedState === 'signedIn') {
            authBtnTxt = _options.signOutStr || Selectors.DEFAULT_SIGN_OUT_TEXT;

            authLink = authConfig?.appSignOutUrl;
        } else {
            // IMPORTANT: For AAD signInURL may not be set, make sure to generate the approriate URL here
            authBtnTxt = _options.signInStr || Selectors.DEFAULT_SIGN_IN_TEXT;
            authLink = authConfig?.appSignInUrl;
        }

        // Simple HTML that shows either a sign in or a sign out link on the header container
        const noJsTemplate: string = `<div>
                <div class="msame_Header">  
                    <a href="${authLink}" style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 160px;outline-offset:inherit; display: inline-block; line-height: 54px; font-size: 100%; color: rgb(80,80,80); padding: 0 5px;">
                        ${authBtnTxt}
                    </a>
                </div> 
            </div>`;

        const template: string = $(noJsTemplate).html();

        $('#' + _options.containerId).html(template);

        /* tslint:disable no-console */
        console.log('LoadFailed: Reverted to fallback');
        /* tslint:enable no-console */
    }

    /**
     * Handles dropdown menu click
     * Opens the dropdown/accordion menu on click.
     * @param ev Click Event
     */
    onHandleMenuClick(ev: JQuery.MouseDownEvent | JQuery.KeyDownEvent): void {
        const $menuToggleButton: JQuery<any> = $(ev.target);

        const keyCode: number = ev.keyCode ? ev.keyCode : ev.which;

        // Handle only Enter/Space within this method.
        if (ev.type === 'keydown' && keyCode !== keyCodeEnter && keyCode !== keyCodeSpace) return;

        ev.stopPropagation();
        ev.preventDefault();

        const isDesktopViewport: MediaQueryList = window.matchMedia(`(min-width: ${Breakpoints.Desktop_Min}px)`);

        /**
         * Header uses dropdown menu for desktop resolution & accordion menu
         * for tablet/mobile resolution.
         *
         * Dropdown Menu classes - `is-dropdown-submenu-parent`, `is-dropdown-submenu`, `js-dropdown-active`
         * Accordion Menu classes - `is-accordion-submenu-parent`, `is-accordion-submenu`, `is-active`
         */
        if (isDesktopViewport.matches) {
            // Desktop resolution
            this.setDropdownMenuDirectionClass($menuToggleButton);
            this._onHandleDropdownMenuClick($menuToggleButton);
        } else {
            // Tablet, Mobile resolution
            this._onHandleAccordionMenuClick($menuToggleButton);
        }

        $menuToggleButton.focus();
    }

    /**
     * Adds the direction class for more-menu
     */
    setDropdownMenuDirectionClass($element: JQuery<any>): void {
        let clientRect: DOMRect;
        let $rootMenuElement: JQuery<any>;

        // Get the reference for top-most dropdown menu.
        if ($element && $element.length) {
            const $menus: JQuery<any> = $element.parentsUntil('[data-menu-left]', Selectors.DROPDOWN_MENU_PARENT);
            $rootMenuElement = $menus && $menus.length ? $($menus.get($menus.length - 1)) : null;
            const rootMenuDropdownElement: any = $rootMenuElement.children(Selectors.MENU_BUTTON).get(0) ?? null;

            if (rootMenuDropdownElement) {
                clientRect = rootMenuDropdownElement?.getBoundingClientRect();
            }
        }

        if (clientRect) {
            const { left, right }: DOMRect = clientRect;

            const isRTL: boolean = document && document.dir === 'rtl';

            const elementX: number = isRTL ? right : left;

            const shouldReverseDirection: boolean = isRTL
                ? elementX - SubMenuWidth * 2 - MinSpaceBeforeDirectionReverse < 0
                : elementX + SubMenuWidth * 2 + MinSpaceBeforeDirectionReverse > this.$rootContainer.width();

            if (shouldReverseDirection) {
                $rootMenuElement.addClass('js-direction-reversed');
            } else {
                $rootMenuElement.removeClass('js-direction-reversed');
            }
        }
    }

    onHandleSubMenuItemFocus(ev: JQuery.FocusEvent): void {
        const $this: JQuery<any> = $(ev.target);

        // Get all the open sub-menu's that are adjuscent to the current menu.
        const $openMenus: JQuery<any> = $this
            .parent()
            .siblings(`${Selectors.DROPDOWN_MENU_PARENT}${Selectors.DROPDOWN_MENU_PARENT_OPEN}`);

        // Close then adjuscent sub-menu's after they have lost focus.
        if ($openMenus && $openMenus.length) {
            $openMenus.removeClass(CssClassNames.DROPDOWN_MENU_PARENT_OPEN);

            $openMenus
                .find(`${Selectors.DROPDOWN_MENU_SUBMENU}${Selectors.DROPDOWN_MENU_SUBMENU_OPEN}`)
                .removeClass(CssClassNames.DROPDOWN_MENU_SUBMENU_OPEN);

            const $button: JQuery<HTMLButtonElement> = $($openMenus.children(Selectors.MENU_BUTTON).get(0));

            this._adjustNestedMenuHeights($button, false);
        }
    }

    // Support Up/Down Arrow keys within submenu.
    onHandleMenuKeydown(ev: JQuery.KeyDownEvent): void {
        if (!ev) return;

        // Handle keydown only for desktop viewport and not for accordion menu.
        if (this.IsLeftMenuAccordion && this.IsHamburgerMenuOpen) return;

        if (ev.keyCode === keyCodeArrowDown) {
            this._onHandleMenuKeydownArrowDownKey(ev);
        } else if (ev.keyCode === keyCodeArrowUp) {
            this._onHandleMenuKeydownArrowUpKey(ev);
        } else if (ev.keyCode === keyCodeEscape) {
            this._onHandleMenuKeydownEspaceKey(ev);
        }
    }

    /**
     * If this is last item on left menu [data-menu-left], then
     * Tab Key should Close the menu before moving tab focus to right menu.
     * @param ev Keyboard Event
     */
    onHandleLastMenuItemKeydown(ev: JQuery.KeyDownEvent): void {
        if (!ev) return;

        if (ev.keyCode === keyCodeTab && !ev.shiftKey) {
            ev.stopPropagation();
            this._closeAllMenus();
        }
    }

    /**
     * Hamburger menu uses absolute positioning.
     * On Shift + Tab, Close the menu and shift tab focus to hamburger menu.
     * @param ev Keyboard Event
     */
    onHandleFirstMenuItemKeydown(ev: JQuery.KeyDownEvent): void {
        if (!ev) return;

        if (ev.keyCode === keyCodeTab && ev.shiftKey && this.IsHamburgerMenuOpen) {
            this.$hamburgerMenuButton.focus();
            ev.preventDefault();
            ev.stopPropagation();
        }
    }

    /**
     * Shift tab focus to next element within the sub-menu on Keyboard Arrow down keystoke.
     * @param ev - Keydown Event
     */
    _onHandleMenuKeydownArrowDownKey(ev: JQuery.KeyDownEvent): void {
        if (!ev) return;

        const $htmlTargetElement: JQuery<HTMLAnchorElement | HTMLButtonElement> = $(ev.target) as JQuery<
            HTMLAnchorElement | HTMLButtonElement
        >;

        // Find all the focussable elements under the closes submenu.
        let $focussableSubMenuElements: any = [];
        if (!this.IsLeftMenuAccordion) {
            $focussableSubMenuElements = $htmlTargetElement
                .closest(Selectors.DROPDOWN_MENU_SUBMENU)
                .find(' > li > a:not(:disabled), > li > button:not(:disabled)');
        } else {
            $focussableSubMenuElements = $htmlTargetElement
                .closest(Selectors.ACCORDION_MENU_SUBMENU)
                .find(' > li > a:not(:disabled), > li > button:not(:disabled)');
        }

        let elementIndex: number = -1;
        $focussableSubMenuElements.each(function (index: number): void {
            if ($(this).is($htmlTargetElement)) {
                elementIndex = index;
            }
        });

        // Cycle through the menu items and focus the next item on the list.
        // If this is the last item in sub-menu then move focus to first item.
        $focussableSubMenuElements[(elementIndex + 1) % $focussableSubMenuElements.length].focus();

        ev.stopPropagation();
        ev.preventDefault();
    }

    /**
     * Shift tab focus to previous item on Arrow Up Keystroke.
     * @param ev Keyboard Event
     */
    _onHandleMenuKeydownArrowUpKey(ev: JQuery.KeyDownEvent): void {
        if (!ev) return;

        const $htmlTargetElement: JQuery<HTMLAnchorElement | HTMLButtonElement> = $(ev.target) as JQuery<
            HTMLAnchorElement | HTMLButtonElement
        >;

        // Find all the focussable elements under the closes submenu.
        let $focussableSubMenuElements: any = [];
        if (!this.IsLeftMenuAccordion) {
            $focussableSubMenuElements = $htmlTargetElement
                .closest(Selectors.DROPDOWN_MENU_SUBMENU)
                .find(' > li > a:not(:disabled), > li > button:not(:disabled)');
        } else {
            $focussableSubMenuElements = $htmlTargetElement
                .closest(Selectors.ACCORDION_MENU_SUBMENU)
                .find(' > li > a:not(:disabled), > li > button:not(:disabled)');
        }

        let elementIndex: number = -1;
        $focussableSubMenuElements.each(function (index: number): void {
            if ($(this).is($htmlTargetElement)) {
                elementIndex = index;
            }
        });

        // If this is the first item in sub-menu, then move tab focus to last item.
        // Else, move tab focus to previos li element.
        if (elementIndex === 0) {
            $focussableSubMenuElements[$focussableSubMenuElements.length - 1].focus();
        } else {
            $focussableSubMenuElements[elementIndex - 1].focus();
        }

        ev.stopPropagation();
        ev.preventDefault();
    }

    _onHandleMenuKeydownEspaceKey(ev: JQuery.KeyDownEvent): void {
        if (!ev) return;

        ev.stopPropagation();

        const $focussedElement: JQuery<HTMLAnchorElement | HTMLButtonElement> = $(ev.target) as JQuery<
            HTMLAnchorElement | HTMLButtonElement
        >;

        const $parents: JQuery<any> = $focussedElement.parentsUntil('[data-menu-left]', Selectors.DROPDOWN_MENU_PARENT);

        if (!$parents && $parents.length) return;

        const topMostParentElement: any = $parents.get($parents.length - 1);

        const $menuToggleButton: JQuery<any> = $(topMostParentElement).find(` > ${Selectors.MENU_BUTTON}`)?.first();

        if ($menuToggleButton) {
            // Bug fix - https://msazure.visualstudio.com/One/_queries/edit/8351376/?triage=true
            this._closeSubMenus(ev);
        }
    }

    _onHandleMenuKeydownEspaceKeyMobile(ev: JQuery.KeyDownEvent): void {
        if (!ev) return;

        ev.stopPropagation();

        const $focussedElement: JQuery<HTMLAnchorElement | HTMLButtonElement> = $(ev.target) as JQuery<
            HTMLAnchorElement | HTMLButtonElement
        >;

        const $parents: JQuery<any> = $focussedElement.parentsUntil(
            '[data-menu-left]',
            Selectors.ACCORDION_MENU_PARENT
        );

        if (!$parents && $parents.length) return;

        const topMostParentElement: any = $parents.get($parents.length - 1);

        const $menuToggleButton: JQuery<any> = $(topMostParentElement).find(` > ${Selectors.MENU_BUTTON}`)?.first();

        if ($menuToggleButton) {
            // Tablet, Mobile resolution
            this._closeSubAccordionMenus(ev);
        }
    }

    onHandleHamburgerMenuClick(ev: JQuery.ClickEvent): void {
        if (!ev.target) return;

        ev.stopPropagation();

        if (!this.$hamburgerMenuButton && !this.$leftMenu) return;

        this.$hamburgerMenuButton.toggleClass(CssClassNames.HAMBURGER_MENU_OPEN);

        this.$hamburgerMenuButton.hasClass(CssClassNames.HAMBURGER_MENU_OPEN)
            ? this.$leftMenu.addClass(CssClassNames.ACCORDION_MENU_EXPANDED).slideDown()
            : this.$leftMenu.removeClass(CssClassNames.ACCORDION_MENU_EXPANDED);

        this.$hamburgerMenuButton.hasClass(CssClassNames.HAMBURGER_MENU_OPEN)
            ? this.$hamburgerMenuButton.attr('aria-expanded', 'true')
            : this.$hamburgerMenuButton.attr('aria-expanded', 'false');
    }

    /**
     * Handle Key down event on hamburger menu.
     * @param ev KeyDownEvent
     */
    onHandleHamburgerKeydown(ev: JQuery.KeyDownEvent): void {
        if (!ev) return;

        if (ev.keyCode === keyCodeTab && !ev.shiftKey && this.IsHamburgerMenuOpen) {
            ev.preventDefault();

            const leftMenuFocussableElements: any = this.$leftMenu.find(
                'button:not(:hidden), [href]:not(:hidden), [tabindex]:not([tabindex="-1"])'
            );

            const rightMenuFocussableElements: any = this.$leftMenu.find(
                'button:not(:hidden), [href]:not(:hidden), [tabindex]:not([tabindex="-1"])'
            );

            const combinedFocussableElements: any[] = [
                ...Array.from(leftMenuFocussableElements),
                ...Array.from(rightMenuFocussableElements),
            ];

            if (combinedFocussableElements && combinedFocussableElements.length) {
                combinedFocussableElements[0].focus();
            }
        } else if (ev.shiftKey && ev.keyCode === keyCodeTab) {
            ev.preventDefault();
            if (this.$meControlDesktop?.length) {
                this.$meControlDesktop.find('[tabindex]').focus();
            } else {
                this.$brand.find('[href]').focus();
            }

            if (this.IsHamburgerMenuOpen) {
                this._closeAllMenus();
            }
        } else if (ev.keyCode === keyCodeEscape) {
            if (this.IsHamburgerMenuOpen) {
                this._closeAllMenus();
            }
        }
    }

    onHandleFocus(ev: JQuery.FocusEvent | JQuery.KeyDownEvent): void {
        const $focussedElement: JQuery<HTMLButtonElement | HTMLAnchorElement> = $(ev.target);

        const level: number = this.getSubmenuLevel($focussedElement);

        if (level === 3) return;

        this._closeOpenSubMenuAtSameLevel(ev);
    }

    /**
     * Catch all block for Document click event.
     *
     * Behavior -
     *  -   Close the hamburger/sub-menus if user clicks on non
     *      interactive menu elements.
     *
     *  -   Clicking on sub-menu won't fire this event as the captured event is
     *      not propagated up the chain.
     */
    onHandleDocumentClick(ev: JQuery.ClickEvent): void {
        if (!ev) return;

        if ($(ev.target).is('body')) return;

        const isFocusWithinHeaderContainer: boolean = $.contains(this.$rootContainer.get(0), ev.target);

        if (isFocusWithinHeaderContainer) return;

        this._closeAllMenus();
    }

    onHandleDocumentKeydown(ev: JQuery.KeyDownEvent): void {
        if (!ev) return;

        const isFirstLevelMenuItems: boolean =
            this.$leftMenu.find(Selectors.MENU_ELEMENTS).length === $(`.${CssClassNames.ACCORDION_MENU}.${CssClassNames.ACCORDION_MENU}`).children(":not(:hidden)").length;
        
        const isDesktopViewport: MediaQueryList = window.matchMedia(`(min-width: ${Breakpoints.Desktop_Min}px)`);

        if (ev.keyCode === keyCodeEscape) {
            // Mobile Resolution
            if(!isDesktopViewport.matches) {
                this._onHandleMenuKeydownEspaceKeyMobile(ev);

                // Set focus to hamburger menu on escape key only if current focus is within first level accordion menu
                if (isFirstLevelMenuItems && this.IsHamburgerMenuOpen) {
                    this.$hamburgerMenuButton?.trigger('click').focus();
                }
            } 
            // Desktop Resolution
            else {
                this._closeAllMenus();
            }
        }
    }

    /**
     * Enable sticky behaviour if [data-sticky-header] is set for <header> element.
     */
    onHandleWindowScroll(): void {
        const scrollTop: number = $(window).scrollTop() ?? 0;
        const isDesktopViewport: MediaQueryList = window.matchMedia(`(min-width: ${Breakpoints.Desktop_Min}px)`);

        if (scrollTop > HeaderHeight * 2) {
            if (!this.$rootContainer?.hasClass(CssClassNames.HEADER_STICKY)) {
                this.$rootContainer?.hide().addClass(CssClassNames.HEADER_STICKY).show();
            }
        } else {
            this.$rootContainer?.removeClass(CssClassNames.HEADER_STICKY);
        }

        // Disable sticky header for mobile viewport
        if (!isDesktopViewport.matches) {
            this.$rootContainer?.removeClass(CssClassNames.HEADER_STICKY);
        }
    }
    // Creating a reference for the throttled function which can be used to de-register event handler during unmount.
    private debouncedOnHandleWindowScroll: () => void = debounce(this.onHandleWindowScroll, 100);

    onHandleWindowResize(): void {
        const isDesktopViewport: MediaQueryList = window.matchMedia(`(min-width: ${Breakpoints.Desktop_Min}px)`);

        // const isMoreMenuDirectionFlipped = window.matchMedia

        // Mobile resolution
        if (!isDesktopViewport.matches) {
            // Close all menus when moving from desktop to mobile resolution
            if (!this.IsLeftMenuAccordion) {
                this._closeAllMenus();
                if (this.useMeControl && this.$meControlMobile.length > 0) {
                    this.loadMeControl(Selectors.ME_CONTROL_ID_MOBILE);
                }
                this.setMeControlMobileState(RuntimeDisplayMode.Compressed);
            }

            this._resetMoreMenu();

            this.$leftMenu.removeClass(CssClassNames.DROPDOWN_MENU).addClass(CssClassNames.ACCORDION_MENU);

            // Switch from dropdown menu to accordion menu
            this.$leftMenu
                .find('.is-dropdown-submenu-parent.opens-right')
                .removeClass('is-dropdown-submenu-parent opens-right')
                .addClass('is-accordion-submenu-parent');

            this.$leftMenu
                .find('.is-dropdown-submenu')
                .removeClass('is-dropdown-submenu')
                .addClass('is-accordion-submenu nested bapi-hide');
        }
        // Desktop resolution
        else {
            // Close all menus when moving from mobile to desktop resolution
            if (this.IsLeftMenuAccordion) {
                this._closeAllMenus();
                if (this.useMeControl && this.$meControlDesktop.length > 0) {
                    this.loadMeControl(Selectors.ME_CONTROL_ID);
                }
                this.setMeControlMobileState(RuntimeDisplayMode.Standard);
            }

            this.$leftMenu.removeClass(CssClassNames.ACCORDION_MENU).addClass(CssClassNames.DROPDOWN_MENU);

            // Switch from accordion menu to dropdown menu
            this.$leftMenu
                .find('.is-accordion-submenu-parent')
                .removeClass('is-accordion-submenu-parent')
                .addClass('is-dropdown-submenu-parent opens-right');

            this.$leftMenu
                .find('.is-accordion-submenu.nested')
                .removeClass('is-accordion-submenu nested')
                .removeClass('bapi-hide')
                .addClass('is-dropdown-submenu');

            this.$leftMenu.removeClass('bapi-accordion-menu').addClass('bapi-dropdown');

            // Calculate and adjust more menu only if the more menu element is available on DOM.
            if (this.$moreMenu) {
                this.adjustMoreMenuItems();
            }
        }
    }

    private debouncedOnHandleWindowsResize: () => void = debounce(this.onHandleWindowResize, 30, { leading: true });

    private adjustMoreMenuItems(reset: boolean = false): void {
        //  calculateElementWidths() function is recursive.
        //  Set IsMoreMenuAdjustmentsInProgress to true to prevent function from calling again while adjustments are in progress.
        if (!this.IsMoreMenuAdjustmentsInProgress) {
            this.IsMoreMenuAdjustmentsInProgress = true;
            this.calculateElementWidths();
            this.IsMoreMenuAdjustmentsInProgress = false;
        }
    }

    /**
     * Resets & Removes all the `More` menu li elements back to regular menu.
     */
    private _resetMoreMenu(): void {
        if (this.IsMoreMenuAdjustmentsInProgress || this.IsMoreMenuEmpty) return;

        this.IsMoreMenuAdjustmentsInProgress = true;

        let loopKillSwitch: number = 0;

        while (!this.IsMoreMenuEmpty) {
            const $firstMoreMenuElement: any = this.$moreMenuList.find(' > li').first();

            $firstMoreMenuElement.insertBefore(this.$moreMenu);
            $firstMoreMenuElement.removeAttr('data-width');

            loopKillSwitch++;

            // If this loop runs over 200 times, kill it to prevent UI from becoming unresponsive.
            if (loopKillSwitch > 200) break;
        }

        this.IsMoreMenuEmpty ? this.$moreMenu?.hide() : this.$moreMenu?.show();

        this.IsMoreMenuAdjustmentsInProgress = false;
    }

    /**
     * Returns total width of all menu elements and total Nav Width
     */
    private calculateElementWidths(): void {
        const includeMargins: boolean = true;

        const [requiredSpace, navWidth]: [number, number] = this.calculateAvailableMenuSpace();

        // If body / Enclosing div is set to display: none, then widths returned will be 0.
        // Gaurd against 0 widths.
        if (requiredSpace === 0 || navWidth === 0) return;

        // If required space is less than available space then shrink to More Menu
        if (requiredSpace + MoreMenuMinSpace > navWidth) {
            // Move last li item to more menu
            const $lastItem: any = this.$leftMenu.find(' > li:not(.more)').last();
            $lastItem.attr('data-width', $lastItem.outerWidth(includeMargins) || 0);
            $lastItem.addClass(CssClassNames.DROPDOWN_MENU_MORE_MENU_NESTED);
            this.$moreMenuList.prepend($lastItem);
            !this.IsMoreMenuEmpty ? this.$moreMenu?.show() : this.$moreMenu?.hide();
            this.calculateElementWidths();
        } else {
            // required space is less than available, if more menu has elements move them back to regular menu.
            if (this.IsMoreMenuEmpty) return;
            // Move last li item outside more menu to main menu.
            const $firstMoreMenuElement: JQuery<any> = this.$moreMenuList.find(' > li').first();

            let requiredWidth: number = requiredSpace + ($firstMoreMenuElement.data('width') ?? 0) + MoreMenuMinSpace;

            // if this is the last item within more menu, then substract width of more menu from required width
            if (this.moreMenuItemCount === 1) {
                requiredWidth = requiredWidth - this.$moreMenuButton?.width();
            }

            if (requiredWidth < navWidth) {
                $firstMoreMenuElement.insertBefore(this.$moreMenu);
                $firstMoreMenuElement.removeAttr('data-width');
                $firstMoreMenuElement.removeClass(CssClassNames.DROPDOWN_MENU_MORE_MENU_NESTED);

                this.IsMoreMenuEmpty ? this.$moreMenu?.hide() : this.$moreMenu?.show();

                this.calculateElementWidths();
            }
        }
    }

    private calculateAvailableMenuSpace(): [number, number] {
        const includeMargins: boolean = true;

        const logoWidth: number = this.$logo && this.$logo.length ? this.$logo.outerWidth(includeMargins) ?? 0 : 0;
        const brandNameWidth: number =
            this.$brand && this.$brand.length ? this.$brand.outerWidth(includeMargins) ?? 0 : 0;
        const separatorWidth: number =
            this.$separator && this.$separator.length ? this.$separator.outerWidth(includeMargins) ?? 0 : 0;

        const navWidth: number = this.$topbarContainer.outerWidth(!includeMargins) ?? 0;

        const rightMenuWidth: number =
            this.$rightMenu && this.$rightMenu.length ? this.$rightMenu.outerWidth(includeMargins) ?? 0 : 0;

        const leftMenuItems: any = this.$leftMenu.find(' > li:not(.more)');

        let leftMenuWidth: number = 0;

        leftMenuItems.each((index: number, element: any): void => {
            leftMenuWidth += $(element).outerWidth(includeMargins) ?? 0;
        });

        let requiredSpace: number = logoWidth + brandNameWidth + separatorWidth + rightMenuWidth + leftMenuWidth;

        if (this.$moreMenu && this.$moreMenu.is(':visible')) {
            requiredSpace += this.$moreMenu.outerWidth(includeMargins) ?? 0;
        }

        return [requiredSpace, navWidth];
    }

    /**
     *  Opens/Closes the the dropdown menu
     * @param $this reference to the dropdown button element.
     */
    private _onHandleDropdownMenuClick($this: JQuery<any>): void {
        const isMenuExpanded: boolean = $this
            .parent(Selectors.DROPDOWN_MENU_PARENT)
            .hasClass(CssClassNames.DROPDOWN_MENU_PARENT_OPEN);

        if (!isMenuExpanded) {
            $this.parent(Selectors.DROPDOWN_MENU_PARENT).addClass(CssClassNames.DROPDOWN_MENU_PARENT_OPEN);
            $this.siblings(Selectors.DROPDOWN_MENU_SUBMENU).addClass(CssClassNames.DROPDOWN_MENU_SUBMENU_OPEN);
        } else {
            $this.parent(Selectors.DROPDOWN_MENU_PARENT).removeClass(CssClassNames.DROPDOWN_MENU_PARENT_OPEN);
            $this.siblings(Selectors.DROPDOWN_MENU_SUBMENU).removeClass(CssClassNames.DROPDOWN_MENU_SUBMENU_OPEN);

            // Close all nested menus under this menu.
            $this
                .siblings(Selectors.DROPDOWN_MENU_SUBMENU)
                .find(`${Selectors.DROPDOWN_MENU_SUBMENU}${Selectors.DROPDOWN_MENU_SUBMENU_OPEN}`)
                .removeClass(CssClassNames.DROPDOWN_MENU_SUBMENU_OPEN);

            $this
                .siblings(Selectors.DROPDOWN_MENU_SUBMENU)
                .find(`${Selectors.DROPDOWN_MENU_PARENT}${Selectors.DROPDOWN_MENU_PARENT_OPEN}`)
                .removeClass(CssClassNames.DROPDOWN_MENU_PARENT_OPEN);

            $this
                .siblings(Selectors.DROPDOWN_MENU_SUBMENU)
                .find(`${Selectors.MENU_BUTTON}`)
                .attr('aria-expanded', 'false');
        }

        $this.attr('aria-expanded', isMenuExpanded ? 'false' : 'true');

        this._adjustNestedMenuHeights($this, false);
    }

    /**
     * Adjust heights of flyout menus.
     * @param $this
     * @param isMenuExpanded true if menu is in expanded state.
     */
    private _adjustNestedMenuHeights($this: JQuery<any>, isStabilizationCycle: boolean): void {
        const level: number = this.getSubmenuLevel($this);
        const isCollapsableMenu: boolean = level === 3;

        // If this is second level/third level menu, then height of menu should be equal to first level menu.
        if (level < 2) return;

        // Reset Heights to original size.
        if (!isStabilizationCycle) {
            this.$leftMenu.find('[data-height-adjusted]').height('auto');
            this._adjustNestedMenuHeights($this, true);
            return;
        }

        let $parentMenu: JQuery<any>;

        const $parents: JQuery<any> = $this.parentsUntil('[data-menu-left]', Selectors.DROPDOWN_MENU_PARENT);

        /**
         * For level 2 menu - We need to adjust the height of dropdown menu 1 level up
         * For level 3 menu - We need to adjust the height of dropdown menu 2 level's up
         */
        if (level === 2 && $parents && $parents.length === 2) {
            const parentElement: JQuery<any> = $parents.get(1);
            $parentMenu = $(parentElement) ?? null;
        } else if (level === 3 && $parents && $parents.length === 3) {
            const parentElement: JQuery<any> = $parents.get(2);
            $parentMenu = $(parentElement) ?? null;
        }

        if (!$parentMenu && $parentMenu.length < 1) return;

        const heightOfParentMenu: number = $parentMenu.children(Selectors.DROPDOWN_MENU_SUBMENU).height();

        // If this is a collapsable menu then find the height on closest submenu (scan up) otherwise find height of sibling (scan sideways)
        const heightOfNestedMenu: number = isCollapsableMenu
            ? $this.closest(Selectors.DROPDOWN_MENU_SUBMENU).height()
            : $this.siblings(Selectors.DROPDOWN_MENU_SUBMENU).height();

        if (heightOfNestedMenu < heightOfParentMenu) {
            // Set height of Nested Menu
            if (isCollapsableMenu) {
                $parentMenu
                    .children('.is-dropdown-submenu')
                    .height(heightOfParentMenu)
                    .attr('data-height-adjusted', 'true');
            } else {
                $this
                    .siblings(Selectors.DROPDOWN_MENU_SUBMENU)
                    .height(heightOfParentMenu)
                    .attr('data-height-adjusted', 'true');
            }
        } else {
            $parentMenu
                .children(Selectors.DROPDOWN_MENU_SUBMENU)
                .height(heightOfNestedMenu)
                .attr('data-height-adjusted', 'true');
        }
    }

    private _onHandleAccordionMenuClick($this: JQuery<any>): void {
        const isMenuExpanded: boolean = $this
            .parent(Selectors.ACCORDION_MENU_PARENT)
            .hasClass(CssClassNames.ACCORDION_MENU_PARENT_OPEN);

        !isMenuExpanded
            ? $this.parent(Selectors.ACCORDION_MENU_PARENT).addClass(CssClassNames.ACCORDION_MENU_PARENT_OPEN)
            : $this.parent(Selectors.ACCORDION_MENU_PARENT).removeClass(CssClassNames.ACCORDION_MENU_PARENT_OPEN);

        !isMenuExpanded
            ? $this
                  .siblings(Selectors.ACCORDION_MENU_SUBMENU)
                  .addClass(CssClassNames.ACCORDION_MENU_SUBMENU_OPEN)
                  .removeClass(CssClassNames.ACCORDION_MENU_COLLAPSE_CLASS)
            : $this
                  .siblings(Selectors.ACCORDION_MENU_SUBMENU)
                  .removeClass(CssClassNames.ACCORDION_MENU_SUBMENU_OPEN)
                  .addClass(CssClassNames.ACCORDION_MENU_COLLAPSE_CLASS);

        $this.attr('aria-expanded', isMenuExpanded ? 'false' : 'true');

        this.$leftMenu
            .find(`${Selectors.ACCORDION_MENU_PARENT}:not(${Selectors.ACCORDION_MENU_PARENT_OPEN})`)
            .removeClass('has-accordion-submenu-active');

        const $parents: JQuery<any> = $this.parentsUntil('[data-menu-left]', '.is-accordion-submenu-parent');
        const isNestedAccordionMenu: boolean = $parents.length > 1;

        if ($parents && isNestedAccordionMenu) {
            const $parent: JQuery<any> = $($parents.get($parents.length - 1));
            $parent.addClass('has-accordion-submenu-active');
        }
    }

    private _closeOpenSubMenuAtSameLevel(ev: JQuery.ClickEvent | JQuery.KeyDownEvent | JQuery.FocusEvent): void {
        const $this: JQuery<HTMLElement> = $(ev.target);

        // Dropdown menu's at same level.
        const $menusAtSameLevel: any = $this
            .parent('.is-dropdown-submenu-parent, .is-menu-link')
            .siblings('.is-dropdown-submenu-parent');

        if ($menusAtSameLevel && $menusAtSameLevel.length) {
            $menusAtSameLevel.each((_index: number, element: Element): void => {
                $(element).removeClass(CssClassNames.DROPDOWN_MENU_PARENT_OPEN);
                $(element).find(Selectors.DROPDOWN_MENU_SUBMENU).removeClass(CssClassNames.DROPDOWN_MENU_SUBMENU_OPEN);
                $(element)
                    .find(Selectors.DROPDOWN_MENU_PARENT_OPEN)
                    .removeClass(CssClassNames.DROPDOWN_MENU_PARENT_OPEN);
                $(element).find(Selectors.MENU_BUTTON).attr('aria-expanded', 'false');

                $(element).find('[data-height-adjusted]').height('auto');
            });
        }

        // Accordion menu's at same level.
        const $accordionsAtSameLevel: any = $this
            .parent('.is-accordion-submenu-parent, .is-menu-link')
            .siblings('.is-accordion-submenu-parent');

        if ($accordionsAtSameLevel && $accordionsAtSameLevel.length) {
            $accordionsAtSameLevel.each((_index: number, element: Element): void => {
                $(element).removeClass(CssClassNames.ACCORDION_MENU_PARENT_OPEN);

                // Close all sub-menus under this menu.
                $(element).find(Selectors.ACCORDION_MENU_PARENT).removeClass(CssClassNames.ACCORDION_MENU_PARENT_OPEN);

                $(element)
                    .find(Selectors.ACCORDION_MENU_SUBMENU)
                    .removeClass(CssClassNames.ACCORDION_MENU_SUBMENU_OPEN)
                    .addClass(CssClassNames.ACCORDION_MENU_COLLAPSE_CLASS);
                $(element).find(Selectors.MENU_BUTTON).attr('aria-expanded', 'false');
            });
        }
    }
    /**
     * Closes Submenu one by one dropdown menu.
     * By default the hamburger menu is closed if open.
     */
    private _closeSubMenus(ev: JQuery.KeyDownEvent): void {
        const $target: JQuery<HTMLElement> = $(ev.target);
        if (!$target || $target.length === 0) return;

        const $parent: any = $target
            .parentsUntil('[data-menu-left]', `${Selectors.DROPDOWN_MENU_PARENT}${Selectors.DROPDOWN_MENU_PARENT_OPEN}`)
            .first();

        if ($parent.length === 0) return;

        $parent.removeClass(CssClassNames.DROPDOWN_MENU_PARENT_OPEN);

        $parent
            .find(`${Selectors.DROPDOWN_MENU_SUBMENU}${Selectors.DROPDOWN_MENU_SUBMENU_OPEN}`)
            .removeClass(CssClassNames.DROPDOWN_MENU_SUBMENU_OPEN);

        $parent.find(Selectors.MENU_BUTTON).attr('aria-expanded', 'false').focus();
        /**
         * If hamburger menu is open, then close it.`
         */
        if (this.IsHamburgerMenuOpen) {
            this.$hamburgerMenuButton?.trigger('click');
        }
    }
    /**
     * Closes Submenu one by one accordion menu.
     * By default the hamburger menu is closed if open.
     */
    private _closeSubAccordionMenus(ev: JQuery.KeyDownEvent): void {
        const $target: JQuery<HTMLElement> = $(ev.target);
        if (!$target || $target.length === 0) return;

        const $parent: any = $target
            .parentsUntil('[data-menu-left]', `${Selectors.ACCORDION_MENU_PARENT}${Selectors.ACCORDION_MENU_PARENT_OPEN}`)
            .first();

        if ($parent.length === 0) return;

        $parent.removeClass(CssClassNames.ACCORDION_MENU_PARENT_OPEN);

        $parent
            .find(`${Selectors.ACCORDION_MENU_SUBMENU}${Selectors.ACCORDION_MENU_SUBMENU_OPEN}`)
            .removeClass(CssClassNames.ACCORDION_MENU_PARENT_OPEN)
            .addClass(CssClassNames.ACCORDION_MENU_COLLAPSE_CLASS);

        $parent.find(Selectors.MENU_BUTTON).attr('aria-expanded', 'false').focus();
    }
    /**
     * Closes all the open accordion and dropdown menu.
     * By default the hamburger menu is closed if open.
     */
    private _closeAllMenus(): void {
        // Dropdown Menu
        this.$rootContainer
            .find(`${Selectors.DROPDOWN_MENU_PARENT}${Selectors.DROPDOWN_MENU_PARENT_OPEN}`)
            .removeClass(CssClassNames.DROPDOWN_MENU_PARENT_OPEN);

        this.$rootContainer
            .find(`${Selectors.DROPDOWN_MENU_SUBMENU}${Selectors.DROPDOWN_MENU_SUBMENU_OPEN}`)
            .removeClass(CssClassNames.DROPDOWN_MENU_SUBMENU_OPEN);

        // Accordion Menus
        this.$rootContainer
            .find(`${Selectors.ACCORDION_MENU_PARENT}${Selectors.ACCORDION_MENU_PARENT_OPEN}`)
            .removeClass(CssClassNames.ACCORDION_MENU_PARENT_OPEN);

        this.$rootContainer
            .find(`${Selectors.ACCORDION_MENU_SUBMENU}${Selectors.ACCORDION_MENU_SUBMENU_OPEN}`)
            .removeClass(CssClassNames.ACCORDION_MENU_PARENT_OPEN)
            .addClass(CssClassNames.ACCORDION_MENU_COLLAPSE_CLASS);

        this.$rootContainer.find('[data-height-adjusted]').removeAttr('data-height-adjusted').height('auto');

        // bug fix - https://dev.azure.com/dynamicscrm/CXP/_workitems/edit/1852689
        this.$rootContainer.find(Selectors.MENU_BUTTON).attr('aria-expanded', 'false');

        /**
         * If hamburger menu is open, then close it.`
         */
        if (this.IsHamburgerMenuOpen) {
            this.$hamburgerMenuButton?.trigger('click');
        }
    }

    /**
     * Gets the dropdown nesting level
     * @param $element dropdown menu toggle button
     * Can be 1, 2, or 3
     */
    private getSubmenuLevel($element: JQuery<any>): number {
        return $element.parentsUntil('[data-menu-left]', Selectors.DROPDOWN_MENU_PARENT).length;
    }

    /**
     * Returns true if hamburger manu is open.
     */
    get IsHamburgerMenuOpen(): boolean {
        return this.$hamburgerMenuButton && this.$hamburgerMenuButton.hasClass(CssClassNames.HAMBURGER_MENU_OPEN);
    }

    /**
     * Returns true if left menu is rendered as a accordion menu.
     */
    get IsLeftMenuAccordion(): boolean {
        return this.$leftMenu && this.$leftMenu.hasClass(CssClassNames.ACCORDION_MENU);
    }

    /**
     * Returns true if more menu has elements.
     */
    get IsMoreMenuEmpty(): boolean {
        let hasVisibleChildren: boolean = false;
        if (this.$moreMenuList && this.$moreMenuList.children().length) {
            // Some of the links are hidden on desktop but visible on mobile.

            // IsMoreMenuEmpty return true for those links, So using display property directly because jQuery :hidden property
            // returns true if parent/ancestor element is hidden.
            this.$moreMenuList.children().each((index: number, element: any): any => {
                if ($(element).css('display') !== 'none') {
                    hasVisibleChildren = true;
                }
            });

            return !hasVisibleChildren;
        }

        return true;
    }

    get moreMenuItemCount(): number {
        let count: number = 0;
        if (this.$moreMenuList && this.$moreMenuList.children().length) {
            // Some of the links are hidden on desktop but visible on mobile.

            // IsMoreMenuEmpty return true for those links, So using display property directly because jQuery :hidden property
            // returns true if parent/ancestor element is hidden.
            this.$moreMenuList.children().each((index: number, element: any): any => {
                if ($(element).css('display') !== 'none') {
                    count++;
                }
            });
        }

        return count;
    }

    get useMeControl(): boolean {
        return (
            this.$rootContainer.data(Selectors.ME_CONTROL_ID) &&
            Boolean(this.$rootContainer.data(Selectors.ME_CONTROL_ID)) === true
        );
    }

    /**
     * Unmount/un-register all the event handlers here.
     */
    onUnmountEventHandlers(): void {
        this.$rootContainer.off('mousedown keydown', `${Selectors.MENU_BUTTON}`, this.onHandleMenuClick);

        this.$rootContainer.off('focus', `${Selectors.MENU_BUTTON}`, this.onHandleFocus);

        this.$rootContainer.off('focus', `${Selectors.MENU_LINK}`, this.onHandleFocus);

        this.$rootContainer.off(
            'focus',
            '.is-dropdown-submenu > li > a, .is-dropdown-submenu > li > button',
            this.onHandleSubMenuItemFocus
        );

        this.$leftMenu.off('keydown', Selectors.MENU_LEFT_LAST_ELEMENT, this.onHandleLastMenuItemKeydown);

        this.$leftMenu.off('keydown', Selectors.MENU_LEFT_FIRST_ELEMENT, this.onHandleFirstMenuItemKeydown);

        this.$rootContainer.off(
            'keydown',
            '.is-dropdown-submenu > li > a, .is-dropdown-submenu > li > button',
            this.onHandleMenuKeydown
        );

        if (this.$hamburgerMenuButton && this.$hamburgerMenuButton.length) {
            this.$hamburgerMenuButton.off('click', this.onHandleHamburgerMenuClick);

            this.$hamburgerMenuButton.off('keydown', this.onHandleHamburgerKeydown);
        }

        // Window & Document
        $(document).off('click', this.onHandleDocumentClick);
        $(document).off('keydown', this.onHandleDocumentKeydown);

        $(window).off('resize', this.debouncedOnHandleWindowsResize);

        if (this.$rootContainer.data('stickyHeader')) {
            $(window).off('scroll', this.debouncedOnHandleWindowScroll);
        }
    }
}

const bapiHeader: BapiHeader = new BapiHeader();
(window as any).BapiHeader = bapiHeader;
bapiHeader.load();
